export const VOLUME_OPTIONS = [
	{ value: 'lt_10k', label: '< $10k' },
	{ value: '10k_50k', label: '$10k – $50k' },
	{ value: '50k_200k', label: '$50k – $200k' },
	{ value: '200k_1m', label: '$200k – $1M' },
	{ value: 'gt_1m', label: '$1M+' },
] as const

export const PROCESSOR_OPTIONS = [
	{ value: 'stripe', label: 'Stripe' },
	{ value: 'nmi', label: 'NMI' },
	{ value: 'checkout', label: 'Checkout.com' },
	{ value: 'adyen', label: 'Adyen' },
	{ value: 'braintree', label: 'Braintree' },
	{ value: 'other', label: 'Other' },
] as const

export const PLATFORM_OPTIONS = [
	{ value: 'shopify', label: 'Shopify' },
	{ value: 'checkoutchamp', label: 'CheckoutChamp' },
	{ value: 'funnelish', label: 'Funnelish' },
	{ value: 'stickyio', label: 'Sticky.io' },
	{ value: 'nextcommerce', label: 'NextCommerce' },
	{ value: 'woocommerce', label: 'WooCommerce' },
	{ value: 'other', label: 'Other' },
] as const

export const SIGNUP_STORAGE_KEY = 'signup_wizard_data'
